import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWorkListRecordsCount, setLastVal } from "../../../../app/patientSlice";

export function useWorkListTabs(facilityNumber, countKey) {
  const dispatch = useDispatch();

  const workListRecordsCount = useSelector((state) => state.patient.workListRecordsCount);
  const lastVal = useSelector((state) => state.patient.lastVal);

  const [defaultVerTab, setDefaultVerTab] = useState(lastVal?.selectVerTab ?? 0);

  useEffect(() => {
    if (facilityNumber) {
      dispatch(getWorkListRecordsCount(facilityNumber, countKey));
    }
  }, [dispatch, facilityNumber, countKey]);

  const onSelectVerTab = (index) => {
    setDefaultVerTab(index);
    dispatch(setLastVal({ ...lastVal, selectVerTab: index }));
  };

  const formatCount = (n) => (n ? `(${n})` : "");

  const counts = workListRecordsCount?.[countKey];

  return {
    dispatch,
    defaultVerTab: defaultVerTab <= 1 ? defaultVerTab : 0,
    onSelectVerTab,
    poaCount: formatCount(counts?.poaCount),
    nonpoaCount: formatCount(counts?.nonpoaCount),
    piPoaCount: formatCount(counts?.piPoaCount),
    piNonPoaCount: formatCount(counts?.piNonPoaCount),
    sharpsurgicalDebridement: formatCount(counts?.sharpsurgicalDebridement),
    reviewLockedAssessments: formatCount(counts?.reviewLockedAssessments),
    woundPhotosCount: formatCount(counts?.woundPhotosCount),
  };
}
